import type { AtomEffect } from 'recoil';
import { atom } from 'recoil';
import type { Area } from '@/types/area';
import type { CodeMaster } from '@/types/code-master';
import type { ServiceType } from '@/types/serviceType';

export type SettingState = {
  codeMasters?: CodeMaster[];
  driverId?: string;
  loginId?: string;
  driverManageCompanyId?: string;
  serviceType?: ServiceType;
  areaList?: Area[];
};

const localStorageEffect: (key: string) => AtomEffect<SettingState | undefined> =
  (key: string) =>
  ({ setSelf, onSet }) => {
    const savedValue = sessionStorage.getItem(key);
    if (savedValue != null) {
      setSelf(JSON.parse(savedValue) as SettingState);
    }

    onSet((newValue: SettingState | undefined) => {
      if (newValue) {
        sessionStorage.setItem(key, JSON.stringify(newValue));
      } else {
        sessionStorage.removeItem(key);
      }
    });
  };

export const settingState = atom<SettingState | undefined>({
  key: 'settingState',
  default: { codeMasters: [] },
  effects_UNSTABLE: [localStorageEffect('settingState')],
});
